import { createContext, useContext, useEffect, useRef, useState } from 'react';

/*
    🔥 ESTADO GENÉRICO DE LOS DROPDOWNS DEL HEADER

    Un solo openId para todos. Exclusión mutua gratis: si se abre uno,
    el anterior se cierra porque el id cambió.

    Agregar una utilidad nueva NO toca este archivo.
*/

const HeaderUtilitiesContext = createContext(null);

export const useHeaderUtilities = () => useContext(HeaderUtilitiesContext);

export const HeaderUtilitiesProvider = ({ children }) => {

    const [useOpenId, setOpenId] = useState(null);

    const REF__useRefContainer = useRef(null);

    const onToggle = (id) => setOpenId((prev) => (prev === id ? null : id));

    const onClose = () => setOpenId(null);

    // ---------------------------- 🔥 CIERRE POR CLIC FUERA
    useEffect(() => {

        const onClickOutside = (event) => {
            if (!REF__useRefContainer.current) return;
            if (!REF__useRefContainer.current.contains(event.target)) setOpenId(null);
        };

        document.addEventListener('mousedown', onClickOutside);
        return () => document.removeEventListener('mousedown', onClickOutside);

    }, []);

    // ---------------------------- 🔥 CIERRE CON ESCAPE
    useEffect(() => {

        const onEscape = (event) => { if (event.key === 'Escape') setOpenId(null); };

        document.addEventListener('keydown', onEscape);
        return () => document.removeEventListener('keydown', onEscape);

    }, []);

    // ---------------------------- 🔥 CIERRE AL CAMBIAR DE MODO
    useEffect(() => {

        let PREV_MOBILE = window.innerWidth < 992;

        const onResize = () => {
            const IS_MOBILE = window.innerWidth < 992;
            if (IS_MOBILE !== PREV_MOBILE) { setOpenId(null); PREV_MOBILE = IS_MOBILE; }
        };

        window.addEventListener('resize', onResize);
        return () => window.removeEventListener('resize', onResize);

    }, []);

    const VALUE = { useOpenId, onToggle, onClose };

    return (
        <HeaderUtilitiesContext.Provider value={VALUE}>
            <div className="LStudio__app_utilities" ref={REF__useRefContainer}>
                {children}
            </div>
        </HeaderUtilitiesContext.Provider>
    );
};